import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sessions: [],
  loading: false,
  error: null
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSessions: (state, action) => {
      state.sessions = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setSessions, setLoading, setError } = sessionSlice.actions;
export default sessionSlice.reducer;
